import React from 'react'
import FluidImage from 'src/utils/FluidImage'
import Label from 'src/components/Label'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'

const ArchiveItem = (item) => {
    return (
        <Link to={resolveLink(item.full_slug)} className="group">
            <FluidImage image={item.content.featured_image} className="mb-3 group-hover:opacity-70 group-hover:-translate-y-2 duration-300 relative rounded-md"/>
            <Label className="text-teal">{item.field_component.replace(/_/g, ' ')}</Label>
            <h3 className="text-blue text-base leading-[1.3rem] tracking-[0.01em] font-semibold">{item.name}</h3>
        </Link>
    )
}

export default ArchiveItem